import { ref } from 'vue'
import { checkPremium } from '@weathernews/btos-javascript-modules/src/wniutil/auth.js'

export default defineNuxtPlugin(async (nuxtApp) => {
  const isPremium = ref(false)

  try {
    await checkPremium()
    isPremium.value = true
  } catch {
    isPremium.value = false
  }

  nuxtApp.provide('isPremium', isPremium)
})
